import React, { useState, useEffect } from "react";
import DashboardHeader from "../../../components/layout/DashboardHeader";
import Sidebar from "../../../components/layout/Sidebar";
import { IoSearch } from "react-icons/io5";
import axios from "axios";
import { BASE_URL } from "../../../env";
import AddBranchModal from "./AddBranchModal";
import { MdModeEdit } from "react-icons/md";
import { Modal, Button, Form, Pagination } from "react-bootstrap";
import Select from "react-select";
import {
  accessTypeOptions,
  accessTypeStringToOptions,
  accessTypeOptionsToString,
} from "../constants/accessTypes";
import { IoMdAdd } from "react-icons/io";
import CustomPagination from "../../../components/ui/CustomPagination";

const AdminBranchList = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [openSidebarToggle, setOpenSidebarToggle] = useState(window.innerWidth > 992);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [branches, setBranches] = useState([]);
  const [filteredBranches, setFilteredBranches] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [branchesPerPage] = useState(20);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [divisions, setDivisions] = useState([]);
  const [validationError, setValidationError] = useState("");
  const [selectedBranch, setSelectedBranch] = useState({
    id: null,
    branchName: "",
    branchCode: "",
    divisionId: null,
  });

  const fetchBranches = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/getall/branches`);

      setBranches(response.data);
      setFilteredBranches(response.data);
      // console.log("BranchList: " + JSON.stringify(response.data));
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchDivisions = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/getall/divisions`);

      setDivisions(response.data);
    } catch (error) {
      console.error("Error fetching divisions:", error);
    }
  };

  useEffect(() => {
    const filtered = branches.filter((branch) =>
      branch.branchName.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredBranches(filtered);
    setCurrentPage(1);
  }, [searchQuery, branches]);

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const handleAddBranchClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleEditBranch = (branch) => {
    fetchDivisions();
    setSelectedBranch({
      ...branch,
      divisionId: {
        value: branch.division.id,
        label: branch.division.divisionName,
      },
    });
    setEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setEditModalOpen(false);
    setSelectedBranch(null);
  };

  const handleSaveChanges = async () => {
    if (
      !selectedBranch.branchCode ||
      !selectedBranch.branchName ||
      !selectedBranch.divisionId
    ) {
      setValidationError("Please Enter All Fields");
      return;
    }

    try {
      const response = await axios.put(`${BASE_URL}/api/admin/editbranch`, {
        branchId: selectedBranch.id,
        branchName: selectedBranch.branchName,
        branchCode: selectedBranch.branchCode,
        divisionId: selectedBranch.divisionId.value,
        accessType: selectedBranch.accessType,
      });
      if (response.status === 200) {
        fetchBranches();
        handleCloseEditModal();
      } else {
        setValidationError("Error: " + response.data.error);
        console.error("Failed to update branch details");
      }
    } catch (error) {
      console.error("Error updating branch details:", error);
    }
  };

  const indexOfLastBranch = currentPage * branchesPerPage;
  const indexOfFirstBranch = indexOfLastBranch - branchesPerPage;
  const currentBranches = filteredBranches.slice(
    indexOfFirstBranch,
    indexOfLastBranch
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredBranches.length / branchesPerPage);

  return (
    <section className="master-layout">
      <div className="master-sidebar-wrapper">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
      </div>

      <div className="master-content-wrapper">
        <div className="master-header-wrapper">
          <DashboardHeader OpenSidebar={OpenSidebar} />
        </div>

        <div className="master-card-container">
          <div className="master-search-section inline-header">
            <div className="d-flex align-items-center gap-3 flex-wrap">
              <h1 className="TableHeaderText m-0">Partner List</h1>
              <div className="search-input-wrapper">
                <input
                  type="text"
                  placeholder="Search by Partner name"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                />
                <span className="search-icon">
                  <IoSearch />
                </span>
              </div>
            </div>

            <button
              className="btn btn-addCredential m-0"
              onClick={handleAddBranchClick}
            >
              <IoMdAdd />
              Add Branch
            </button>
          </div>

          <div className="master-list-section">
            <div className="master-table-wrapper table-responsive">
              <table className="mx-auto table table-striped table-list">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Partner Code</th>
                    <th>Partner Name</th>
                    <th>Access Type</th>
                    <th>Division Code</th>
                    <th>Division Name</th>
                    <th>Region Code</th>
                    <th>Region Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentBranches.length > 0 ? (
                    currentBranches.map((branch, index) => (
                      <tr key={branch.id}>
                        <td>
                          {index + 1 + (currentPage - 1) * branchesPerPage}
                        </td>
                        <td>{branch.branchCode}</td>
                        <td>{branch.branchName}</td>
                        <td>{branch.accessType}</td>
                        <td>{branch.division.divisionCode}</td>
                        <td>{branch.division.divisionName}</td>
                        <td>{branch.division.region.regionCode}</td>
                        <td>{branch.division.region.regionName}</td>

                        <td>
                          <button
                            className="btn btn-edit"
                            title="Edit"
                            onClick={() => handleEditBranch(branch)}
                          >
                            <MdModeEdit />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" className="text-center">
                        No branches found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="master-pagination-wrapper">
              <CustomPagination
                totalPages={totalPages}
                currentPage={currentPage}
                paginate={paginate}
                totalItems={filteredBranches.length}
              />
            </div>
          </div>
        </div>
      </div>

      <AddBranchModal
        show={isModalOpen}
        handleClose={handleCloseModal}
        fetchBranches={fetchBranches}
      />
      {selectedBranch && (
        <Modal show={editModalOpen} onHide={handleCloseEditModal}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Branch</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="editDivision">
                <Form.Label className="pt-2">Division</Form.Label>
                <Select
                  value={selectedBranch.divisionId}
                  onChange={(selectedOption) =>
                    setSelectedBranch({
                      ...selectedBranch,
                      divisionId: selectedOption,
                    })
                  }
                  options={divisions.map((division) => ({
                    value: division.id,
                    label: division.divisionName,
                  }))}
                  isClearable
                  placeholder="---Select Division---"
                  className="w-100"
                />
              </Form.Group>
              <Form.Group controlId="editBranchCode">
                <Form.Label className="pt-2">Partner Code</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedBranch.branchCode}
                  onChange={(e) =>
                    setSelectedBranch({
                      ...selectedBranch,
                      branchCode: e.target.value,
                    })
                  }
                />
              </Form.Group>
              <Form.Group controlId="editBranchName">
                <Form.Label className="pt-2">Partner Name</Form.Label>
                <Form.Control
                  type="text"
                  value={selectedBranch.branchName}
                  onChange={(e) =>
                    setSelectedBranch({
                      ...selectedBranch,
                      branchName: e.target.value,
                    })
                  }
                />
              </Form.Group>
              <h6 className="text-danger">{validationError}</h6>
              {/*
                Access Type. This was a free-text box whose onChange wrote to
                branchName - typing in it renamed the branch - and whose value
                was never sent by handleSaveChanges. It is now the same
                multi-select the add-branch modal uses, sharing one option list
                so the two cannot drift.

                State keeps accessType in its stored form, a comma-separated
                string, so nothing else in this component has to change.
              */}
              <Form.Group controlId="editBranchAccessType">
                <Form.Label className="pt-2">Access Type</Form.Label>
                <Select
                  value={accessTypeStringToOptions(selectedBranch.accessType)}
                  onChange={(selectedOptions) =>
                    setSelectedBranch({
                      ...selectedBranch,
                      accessType: accessTypeOptionsToString(selectedOptions),
                    })
                  }
                  options={accessTypeOptions}
                  isMulti
                  isClearable
                  placeholder="---Select Access Type(s)---"
                  className="w-100"
                />
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseEditModal}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSaveChanges}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </section>
  );
};

export default AdminBranchList;
